export default __webpack_public_path__ + "static/media/sizing.588f965d.png";